import { initFormModalLinks } from '../../shared/formModal.js';
import { initLiveList } from '../../shared/liveList.js';

// The roster's filter, search and paging, plus the create link that opens in
// the shared dialog.
//
// No row actions: a candidate is opened rather than acted on from the list, and
// deleting lives on their own page where the consequence is spelled out.
export function initKandidatList() {
  initLiveList({
    results: 'kandidat-list',
    path: '/kandidaten',
    // Both forms, merged into one query string by liveList - so a search keeps
    // the active filter and vice versa.
    forms: ['kandidat-filter', 'kandidat-search']
  });

  // Also on the list page, so "Kandidat erfassen" opens the dialog rather than
  // navigating. Called unconditionally: it looks up its own links and returns
  // early when there are none.
  initFormModalLinks();
}
